var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("main-right-popup-common", {
        ref: "mainRightPopupCommon",
        attrs: { titleName: "方案分享" },
        on: { loadData: _vm.loadData },
        scopedSlots: _vm._u([
          {
            key: "searchDiv",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.myLineInquiry != 2,
                        expression: "myLineInquiry!=2",
                      },
                    ],
                    staticClass: "searchDiv",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "firstLineSearch" },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: {
                              "margin-right": "0.05rem",
                              width: "1rem",
                            },
                            attrs: { placeholder: "请选择", size: "mini" },
                            model: {
                              value: _vm.dateValue,
                              callback: function ($$v) {
                                _vm.dateValue = $$v
                              },
                              expression: "dateValue",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "制作日期", value: 1 },
                            }),
                            _c("el-option", {
                              attrs: { label: "出发日期", value: 2 },
                            }),
                          ],
                          1
                        ),
                        _c("el-date-picker", {
                          staticStyle: { width: "2.15rem" },
                          attrs: {
                            type: "daterange",
                            size: "mini",
                            "range-separator": "至",
                            "start-placeholder": "开始日期",
                            "end-placeholder": "结束日期",
                            "value-format": "yyyy-MM-dd",
                          },
                          model: {
                            value: _vm.dateArr,
                            callback: function ($$v) {
                              _vm.dateArr = $$v
                            },
                            expression: "dateArr",
                          },
                        }),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "14px",
                              color: "#101010",
                              "margin-left": "0.2rem",
                            },
                          },
                          [_vm._v("今日")]
                        ),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "14px",
                              color: "#101010",
                              "margin-left": "0.1rem",
                            },
                          },
                          [_vm._v("本周")]
                        ),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "14px",
                              color: "#101010",
                              "margin-left": "0.1rem",
                            },
                          },
                          [_vm._v("本月")]
                        ),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "14px",
                              color: "#101010",
                              "margin-left": "0.1rem",
                            },
                          },
                          [_vm._v("近两个月")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "firstLineSearch",
                        staticStyle: { "margin-top": "10px" },
                      },
                      [
                        _c("span", { staticClass: "boldFont" }, [
                          _vm._v("目的地 "),
                        ]),
                        _c("el-input", {
                          staticStyle: { width: "1.48rem" },
                          attrs: { size: "mini" },
                          model: {
                            value: _vm.destination,
                            callback: function ($$v) {
                              _vm.destination = $$v
                            },
                            expression: "destination",
                          },
                        }),
                        _c(
                          "span",
                          {
                            staticClass: "boldFont",
                            staticStyle: { "margin-left": "0.1rem" },
                          },
                          [_vm._v("行程名称 ")]
                        ),
                        _c("el-input", {
                          staticStyle: { width: "1.48rem" },
                          attrs: { size: "mini" },
                          model: {
                            value: _vm.budgetName,
                            callback: function ($$v) {
                              _vm.budgetName = $$v
                            },
                            expression: "budgetName",
                          },
                        }),
                        _c(
                          "el-select",
                          {
                            staticStyle: {
                              "margin-left": "0.05rem",
                              width: "1rem",
                            },
                            attrs: { placeholder: "请选择", size: "mini" },
                            on: {
                              change: function ($event) {
                                return _vm.getListData("empty")
                              },
                            },
                            model: {
                              value: _vm.sortType,
                              callback: function ($$v) {
                                _vm.sortType = $$v
                              },
                              expression: "sortType",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "按修改日期倒序", value: 1 },
                            }),
                            _c("el-option", {
                              attrs: { label: "按出发日期倒序", value: 2 },
                            }),
                            _c("el-option", {
                              attrs: { label: "按出发日期正序", value: 3 },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "createBtn",
                            staticStyle: { "margin-left": "0.35rem" },
                            attrs: { size: "mini", type: "primary" },
                            on: { click: _vm.createPlan },
                          },
                          [_vm._v("创建行程")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticStyle: { "margin-top": "10px" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "2.1rem" },
                          attrs: {
                            size: "mini",
                            placeholder: "客户名称/团号/询单号/生成人",
                          },
                          model: {
                            value: _vm.keyword,
                            callback: function ($$v) {
                              _vm.keyword = $$v
                            },
                            expression: "keyword",
                          },
                        }),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "margin-left": "0.1rem",
                              "font-weight": "bold",
                            },
                          },
                          [_vm._v("天数 ")]
                        ),
                        _c("el-input", {
                          staticStyle: { width: "0.66rem" },
                          attrs: { size: "mini" },
                        }),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "margin-left": "0.1rem",
                              "font-weight": "bold",
                            },
                          },
                          [_vm._v("人数")]
                        ),
                        _c("el-input", {
                          staticStyle: { width: "0.69rem" },
                          attrs: { size: "mini" },
                        }),
                        _c(
                          "span",
                          {
                            staticClass: "searchTravel",
                            on: {
                              click: function ($event) {
                                return _vm.getListData("empty")
                              },
                            },
                          },
                          [_vm._v("搜索")]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.myLineInquiry == 2,
                        expression: "myLineInquiry==2",
                      },
                    ],
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "firstLineSearch" },
                      [
                        _c("span", { staticClass: "boldFont" }, [
                          _vm._v("询单号 "),
                        ]),
                        _c("el-input", {
                          staticStyle: { width: "1.48rem" },
                          attrs: { size: "mini" },
                          model: {
                            value: _vm.inquiryNumber,
                            callback: function ($$v) {
                              _vm.inquiryNumber = $$v
                            },
                            expression: "inquiryNumber",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "firstLineSearch",
                        staticStyle: { "margin-top": "10px" },
                      },
                      [
                        _c("span", { staticClass: "boldFont" }, [
                          _vm._v("目的地 "),
                        ]),
                        _c("el-input", {
                          staticStyle: { width: "1.48rem" },
                          attrs: { size: "mini" },
                          model: {
                            value: _vm.destination,
                            callback: function ($$v) {
                              _vm.destination = $$v
                            },
                            expression: "destination",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticStyle: { "margin-top": "10px" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "2.1rem" },
                          attrs: {
                            size: "mini",
                            placeholder: "客户名称/团号/询单号/生成人",
                          },
                          model: {
                            value: _vm.keyword,
                            callback: function ($$v) {
                              _vm.keyword = $$v
                            },
                            expression: "keyword",
                          },
                        }),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "margin-left": "0.1rem",
                              "font-weight": "bold",
                            },
                          },
                          [_vm._v("天数 ")]
                        ),
                        _c("el-input", {
                          staticStyle: { width: "0.66rem" },
                          attrs: { size: "mini" },
                        }),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "margin-left": "0.1rem",
                              "font-weight": "bold",
                            },
                          },
                          [_vm._v("人数")]
                        ),
                        _c("el-input", {
                          staticStyle: { width: "0.69rem" },
                          attrs: { size: "mini" },
                        }),
                        _c(
                          "span",
                          {
                            staticClass: "searchTravel",
                            on: {
                              click: function ($event) {
                                return _vm.getListData("empty")
                              },
                            },
                          },
                          [_vm._v("搜索")]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "dataDiv",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.myLineInquiry != 2,
                        expression: "myLineInquiry!=2",
                      },
                    ],
                  },
                  _vm._l(_vm.informationList, function (item, index) {
                    return _c(
                      "div",
                      { key: index },
                      [
                        _c("plan-list-info", {
                          attrs: {
                            item: item,
                            planId: _vm.planId,
                            index: index,
                            showInquiryButton: true,
                          },
                          on: {
                            replaceStroke: _vm.replaceStroke,
                            delPlan: _vm.delPlan,
                            copyPlan: _vm.copyPlan,
                            goXunList: _vm.goXunList,
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.myLineInquiry == 2,
                        expression: "myLineInquiry==2",
                      },
                    ],
                  },
                  [
                    _vm._l(_vm.myProgramData, function (item, index) {
                      return [
                        _c(
                          "div",
                          { key: index, staticClass: "makeByInquiry" },
                          [
                            _c("div", { staticClass: "head" }, [
                              _c("div", { staticClass: "head_left" }, [
                                _c("div", { staticClass: "title" }, [
                                  _c(
                                    "div",
                                    { staticClass: "planName" },
                                    _vm._l(
                                      item.destination,
                                      function (itemTwo, indexTwo) {
                                        return _c(
                                          "span",
                                          {
                                            key: indexTwo,
                                            style: `margin-left:${
                                              indexTwo == 0 ? "0" : "5"
                                            }px;`,
                                          },
                                          [_vm._v(_vm._s(itemTwo.cityName))]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "planName",
                                      staticStyle: { "margin-left": "10px" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            item.inquiryMaintainList[0]
                                              .estimatedTravelEnd === ""
                                              ? ""
                                              : (item.inquiryMaintainList[0]
                                                  .estimatedTravelEnd -
                                                  item.inquiryMaintainList[0]
                                                    .estimatedTravelStart) /
                                                  86400000 +
                                                  1 +
                                                  "天"
                                          ) +
                                          " " +
                                          _vm._s(
                                            new Date(
                                              item.inquiryMaintainList[0].estimatedTravelStart
                                            ).getMonth() +
                                              1 +
                                              "." +
                                              new Date(
                                                item.inquiryMaintainList[0].estimatedTravelStart
                                              ).getDate()
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("div", [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-size": "14px",
                                        color: "rgba(19, 144, 202, 100)",
                                        display: "inline-block",
                                        width: "122px",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " 询单号：" + _vm._s(item.id) + " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-size": "12px",
                                        color: "#101010",
                                        "margin-left": "40px",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.dateFormatYMDHM(
                                              item.inquiryMaintainList[0]
                                                .grabbingTime,
                                              "-"
                                            )
                                          ) +
                                          " " +
                                          _vm._s(
                                            item.inquiryMaintainList[0]
                                              .customizerName
                                          ) +
                                          "抢单成功 "
                                      ),
                                    ]
                                  ),
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "font-size": "14px",
                                      color: "#101010",
                                      "margin-top": "5px",
                                    },
                                  },
                                  [
                                    item.inquiryMaintainList[0].isSend == 0
                                      ? _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              display: "inline-block",
                                              width: "95px",
                                              height: "21px",
                                              border: "1px solid #1b94cc",
                                              "border-radius": "4px",
                                              "text-align": "center",
                                              "line-height": "19px",
                                              color: "#1b94cc",
                                              "margin-left": "20px",
                                            },
                                          },
                                          [_vm._v("尚未发送方案")]
                                        )
                                      : _vm._e(),
                                    item.inquiryMaintainList[0].isSend == 1
                                      ? _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              display: "inline-block",
                                              width: "95px",
                                              height: "21px",
                                              border: "1px solid #db4e1a",
                                              "border-radius": "4px",
                                              "text-align": "center",
                                              "line-height": "19px",
                                              color: "#db4e1a",
                                              "margin-left": "20px",
                                            },
                                          },
                                          [_vm._v("已发送方案")]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "margin-top": "5px",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          color: "#1b94cc",
                                          display: "flex",
                                          "align-items": "center",
                                          width: "160px",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: { cursor: "pointer" },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                ;(item.isShowMore = true),
                                                  (item.isShowMoreTwo = false)
                                              },
                                            },
                                          },
                                          [_vm._v("询单详情")]
                                        ),
                                        _c("i", {
                                          staticClass: "el-icon-arrow-down",
                                          staticStyle: {
                                            "font-size": "18px",
                                            "margin-left": "10px",
                                            cursor: "pointer",
                                          },
                                          on: {
                                            click: function ($event) {
                                              ;(item.isShowMore = true),
                                                (item.isShowMoreTwo = false)
                                            },
                                          },
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          color: "#e65019",
                                          display: "flex",
                                          "align-items": "center",
                                          width: "160px",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: { cursor: "pointer" },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.showProgramDetails(
                                                  item
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("方案详情")]
                                        ),
                                        _c("i", {
                                          staticClass: "el-icon-arrow-down",
                                          staticStyle: {
                                            "font-size": "18px",
                                            "margin-left": "10px",
                                            cursor: "pointer",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.showProgramDetails(
                                                item
                                              )
                                            },
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "head_right" }, [
                                _c("div", {
                                  staticClass: "right_head",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.goCopy(item)
                                    },
                                  },
                                }),
                                _c("div", { staticClass: "right_center" }),
                                _c(
                                  "div",
                                  {
                                    staticClass: "right_footer",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.makeStroke(item)
                                      },
                                    },
                                  },
                                  [_vm._v(" 制作行程 ")]
                                ),
                              ]),
                            ]),
                            _c(
                              "div",
                              {
                                class: item.isShowMore
                                  ? "body"
                                  : "body_hidden body",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      padding: "10px",
                                      "border-bottom": "1px solid #ddd",
                                      "padding-left": "20px",
                                      display: "flex",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          display: "inline-block",
                                          width: "50px",
                                          height: "20px",
                                          "border-radius": "5px",
                                          "text-align": "center",
                                          "line-height": "20px",
                                          background: "#eb7549",
                                          color: "white",
                                          "margin-left": "10px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              item.type == 1
                                                ? "私家团"
                                                : "企业团"
                                            )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "font-size": "14px",
                                          color: "#101010",
                                          "margin-left": "30px",
                                        },
                                      },
                                      [_vm._v("和客户沟通后信息更新：")]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      padding: "10px",
                                      "padding-left": "20px",
                                      "padding-bottom": "0",
                                      "font-size": "12px",
                                      color: "#101010",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "align-items": "center",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "body_title" },
                                          [_vm._v("公司名称：")]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              display: "inline-block",
                                              width: "130px",
                                              overflow: "hidden",
                                              "text-overflow": "ellipsis",
                                              "white-space": "nowrap",
                                            },
                                            attrs: {
                                              title: item.createCompanyName,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(item.createCompanyName)
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "font-weight": "bold",
                                              color: "#e65019",
                                              "margin-left": "17px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "客户名称：" +
                                                _vm._s(item.createName)
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticStyle: { "margin-top": "10px" } },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "body_title" },
                                          [_vm._v("客户Email：")]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              display: "inline-block",
                                              width: "130px",
                                            },
                                          },
                                          [_vm._v(_vm._s(item.email))]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "font-weight": "bold",
                                              color: "#e65019",
                                              "margin-left": "10px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "客户电话：" +
                                                _vm._s(item.telephone)
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "body_items" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "body_title" },
                                          [_vm._v("目的地: ")]
                                        ),
                                        _vm._l(
                                          item.destination,
                                          function (itemTwo, indexTwo) {
                                            return _c(
                                              "span",
                                              {
                                                key: indexTwo,
                                                style: `margin-left:${
                                                  indexTwo == 0 ? "0" : "10"
                                                }px;`,
                                              },
                                              [_vm._v(_vm._s(itemTwo.cityName))]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                    _c("div", { staticClass: "body_items" }, [
                                      _c(
                                        "span",
                                        { staticClass: "body_title" },
                                        [_vm._v("预估出行日期: ")]
                                      ),
                                      _c("span", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.dateFormatYMD(
                                                item.inquiryMaintainList[0]
                                                  .estimatedTravelStart,
                                                "/"
                                              )
                                            ) +
                                            " "
                                        ),
                                        item.inquiryMaintainList[0]
                                          .estimatedTravelEnd !== ""
                                          ? _c("span", [_vm._v("至")])
                                          : _vm._e(),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              item.inquiryMaintainList[0]
                                                .estimatedTravelEnd === ""
                                                ? ""
                                                : _vm.dateFormatYMD(
                                                    item.inquiryMaintainList[0]
                                                      .estimatedTravelEnd,
                                                    "/"
                                                  )
                                            ) +
                                            " " +
                                            _vm._s(
                                              item.inquiryMaintainList[0]
                                                .estimatedTravelEnd === ""
                                                ? ""
                                                : (item.inquiryMaintainList[0]
                                                    .estimatedTravelEnd -
                                                    item.inquiryMaintainList[0]
                                                      .estimatedTravelStart) /
                                                    86400000 +
                                                    1 +
                                                    "天"
                                            ) +
                                            " "
                                        ),
                                      ]),
                                    ]),
                                    _c("div", { staticClass: "body_items" }, [
                                      _c(
                                        "span",
                                        { staticClass: "body_title" },
                                        [_vm._v("预估出行人数: ")]
                                      ),
                                      _c("span", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              item.inquiryMaintainList[0]
                                                .estimatedTravelAdultNum
                                            ) +
                                            "成人 " +
                                            _vm._s(
                                              item.inquiryMaintainList[0]
                                                .estimatedTravelAdultChildren
                                            ) +
                                            "儿童 "
                                        ),
                                      ]),
                                    ]),
                                    _c("div", { staticClass: "body_items" }, [
                                      _c(
                                        "span",
                                        { staticClass: "body_title" },
                                        [_vm._v("预算：")]
                                      ),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            item.inquiryMaintainList[0].price
                                          ) + " /人"
                                        ),
                                      ]),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            item.inquiryMaintainList[0].type ==
                                              0
                                              ? "不含机票"
                                              : item.inquiryMaintainList[0]
                                                  .type == 1
                                              ? "含经济舱"
                                              : "含公/头等舱"
                                          ) + " "
                                        ),
                                      ]),
                                      item.departurePlace &&
                                      item.departurePlace != ""
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                item.departurePlace.cityName
                                              ) + "出发"
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "body_items" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "body_title" },
                                          [_vm._v("主题：")]
                                        ),
                                        _vm._l(
                                          item.theme,
                                          function (itemTwo, indexTwo) {
                                            return _c(
                                              "span",
                                              {
                                                key: indexTwo,
                                                style: `margin-left:${
                                                  indexTwo == 0 ? "0" : "10"
                                                }px;`,
                                              },
                                              [_vm._v(_vm._s(itemTwo))]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "body_items" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "body_title" },
                                          [_vm._v("行程期待：")]
                                        ),
                                        _vm._l(
                                          item.planExpect,
                                          function (itemTwo, indexTwo) {
                                            return _c(
                                              "span",
                                              {
                                                key: indexTwo,
                                                style: `margin-left:${
                                                  indexTwo == 0 ? "0" : "10"
                                                }px;`,
                                              },
                                              [_vm._v(_vm._s(itemTwo))]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "body_items" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "body_title" },
                                          [_vm._v("所需服务：")]
                                        ),
                                        _vm._l(
                                          item.needService,
                                          function (itemTwo, indexTwo) {
                                            return _c(
                                              "span",
                                              {
                                                key: indexTwo,
                                                style: `margin-left:${
                                                  indexTwo == 0 ? "0" : "10"
                                                }px;`,
                                              },
                                              [_vm._v(_vm._s(itemTwo))]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                    _c("div", { staticClass: "body_items" }, [
                                      _c(
                                        "span",
                                        { staticClass: "body_title" },
                                        [_vm._v("客户留言：")]
                                      ),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            item.inquiryMaintainList[0]
                                              .customerMessage
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticStyle: { "text-align": "right" } },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-caret-top",
                                      staticStyle: {
                                        "font-size": "24px",
                                        cursor: "pointer",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          item.isShowMore = false
                                        },
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                            item.isShowMoreTwo
                              ? _c(
                                  "div",
                                  {
                                    class: item.isShowMoreTwo
                                      ? "body"
                                      : "body_hidden body",
                                    staticStyle: {
                                      padding: "0 15px",
                                      "padding-top": "20px",
                                    },
                                  },
                                  [
                                    _vm._l(
                                      item.programList,
                                      function (itemThree, indexThree) {
                                        return _c(
                                          "div",
                                          {
                                            key: indexThree,
                                            staticClass: "customize_box",
                                            staticStyle: {
                                              margin: "0",
                                              "margin-bottom": "15px",
                                            },
                                          },
                                          [
                                            _c("plan-list-info", {
                                              attrs: {
                                                item: itemThree,
                                                planId: _vm.planId,
                                                index: index,
                                              },
                                              on: {
                                                replaceStroke: function (
                                                  $event
                                                ) {
                                                  return _vm.replaceStroke(
                                                    $event,
                                                    item
                                                  )
                                                },
                                                delPlan: _vm.delPlan,
                                                copyPlan: _vm.copyPlan,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: { "text-align": "right" },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-caret-top",
                                          staticStyle: {
                                            "font-size": "24px",
                                            cursor: "pointer",
                                          },
                                          on: {
                                            click: function ($event) {
                                              item.isShowMoreTwo = false
                                            },
                                          },
                                        }),
                                      ]
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]
                    }),
                  ],
                  2
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("create-plan", { ref: "createPlan" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }